import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

import { createBatchFromSelected } from '../actions/batchActions';
import { CREATE_OR_ADD_TO_BUNDLE_QUANTITIES } from '../actions/dialogActions';
import { RootState } from '../store';
import { showPopup } from '../store/popupSlice';
import { BATCHES_AND_BUNDLES_URL_SLUG } from './Content';
import { useAppDispatch, useAppSelector } from './hooks';

export function KeyboardListener() {
  const dispatch = useAppDispatch();
  const batchesAndBundlesTabActive = useLocation().pathname.includes(BATCHES_AND_BUNDLES_URL_SLUG);
  const productionGroupGridCheckedAnalysisSetGuids = useAppSelector(
    (state: RootState) => state.batchesAndBundlesTab.checkedAnalysisSetGuids,
  );
  const activeGrid = useAppSelector((state: RootState) => state.batchesAndBundlesTab.activeList);

  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      switch (event.key) {
        case 'Enter':
          if (batchesAndBundlesTabActive && productionGroupGridCheckedAnalysisSetGuids.length > 0) {
            dispatch(
              activeGrid === 'batches' ? createBatchFromSelected() : showPopup(CREATE_OR_ADD_TO_BUNDLE_QUANTITIES),
            );
          }
          break;
      }
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  });
  return <div style={{ display: 'none' }} />;
}
